define('views/content/reports/resellers',['require','backbone','marionette','datatables','select2','text!templates/content/reports/resellers.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');
    require('select2');

    var temp = require("text!templates/content/reports/resellers.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'resellers',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                localizationFilter: '#localization',
                statusFilter: '#statuses',
                countryFilter: '#countries',
                groupFilter: '#groups',

                getReportButton: '#report-button',
                getCsvButton: '#csv-button',

                resellersTable: '.resellers-list',
                totalCount: '#total_count'
            };
        },

        events: {
            'click @ui.getReportButton': 'getReportButtonClicked',
            'click @ui.getCsvButton': 'getCsvButtonClicked'
        },

        onRender: function () {
            this.ui.select2Input.select2();
        },

        _getParameters: function() {
            var parameters = '';

            parameters += ('localization=' + this.ui.localizationFilter.val());

            if (this.ui.statusFilter.val()) {
                this.ui.statusFilter.val().forEach(function (statusFilter) {
                    parameters += ('&statuses[]=' + statusFilter);
                });
            }


            if (this.ui.countryFilter.val()) {
                this.ui.countryFilter.val().forEach(function (countryFilter) {
                    parameters += ('&countries[]=' + countryFilter);
                });
            }

            if (this.ui.groupFilter.val()) {
                this.ui.groupFilter.val().forEach(function (group) {
                    parameters += ('&groups[]=' + group);
                });
            }



            return parameters;
        },

        getReportButtonClicked: function() {
          this.getReports();
        },

        getCsvButtonClicked: function() {
            $.ajax({
                url: App.Config.apiBase + 'reports/reseller-data-reports/?' + this._getParameters(),
                method: 'get',
                headers: { 'Accept': 'text/csv' },
                success: function (response) {
                    var encodedUri = encodeURI("data:text/csv;charset=utf-8," + response);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("target", "_blank");
                    link.setAttribute("class", "out");
                    link.setAttribute("download", "resellers.csv");
                    document.body.appendChild(link); // Required for FF
                    link.click();
                }
            });
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/reseller-data-reports/?' + this._getParameters(),
                method: 'get',
                success: function (response) {
                    _this.showResellerReports(response);
                }
            });
        },

        showResellerReports: function (reportData) {
            this.ui.totalCount.html(reportData.length);

            // Transform report data for datatables format
            var gridData = [];

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/reports/reseller-sales?reseller_id=' + reportRow.reseller_id + '">' + reportRow.company_name + '<a/>',
                    '<a href="/reseller-managers/' + reportRow.manager_id + '">' + reportRow.manager_name + '<a/>',
                    reportRow.manager_email,
                    reportRow.country,
                    reportRow.city
                ]);
            });

            if (!this.resellersDataTable) {
                this.resellersDataTable = this.ui.resellersTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.resellersTable),
                    columns: [
                        { title: App.polyglot.t('reseller') },
                        { title: App.polyglot.t('manager') },
                        { title: App.polyglot.t('email') },
                        { title: App.polyglot.t('country') },
                        { title: App.polyglot.t('city') }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.resellersDataTable.clear();
                this.resellersDataTable.rows.add(gridData);
                this.resellersDataTable.columns.adjust().draw();
            }
        }

    });
});
